import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { AccountAdviceType } from "../../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ModelPortfolioTabType } from "../../../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { OrderDirection } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { OrderType } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { DecisionMaker } from "../../../../../../Shared/IST/Components/DecisionMaker";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { QuantitySwitch } from "../../../../../../Shared/QuantitySwitch/QuantitySwitch";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { InvestmentsAction } from "../../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { BuySellAllocationTable } from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTable";
import {
    clearAllocation,
    transformNewItem,
} from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTableHelper";
import { OrderSetupReview } from "../../../Common/Review/Component/OrderSetupReview";
import { hasDecisionMaker } from "../../../Switch/Resource/Content";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { ClientAccountStore, UserStore, TreasuredAssetsStore } from "../../../../../Stroes/Variable";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { Action } from "../../../../../Actions/Action";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { TradableInvestment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/TradableInvestment";
import { ResultPageModel } from "../../../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { DepositProduct } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { DepositProductsQuery } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { InvestmentPathSelection } from "../../../../../../Shared/IST/Components/InvestmentPathSelection";
import { OrderDeferReasonTypeArrays, OrderDeferReasonArraysMap } from "../../../Common/Resource/Contents";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { BatchType } from "../../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { caseInsensitiveMatch } from "../../../../../../../react-core/Utils/String";

interface ISellInvestmentProps extends IProcessComponentProps {
    type: SubAccountType;
    isReview: boolean;
}

interface ISellInvestmentState {
    orderType: OrderType;
    isLoading: boolean;
    userInfo: User;
    treasuredAssetProductIds: Array<number>;
    cashProducts: Record<number, DepositProduct>;
}

export class SellInvestment extends ProcessComponent<ISellInvestmentProps, ISellInvestmentState> {
    constructor(props: any)
    {
        super(props);
        this.state =
            {
                orderType:
                    props.data.InvestmentList && props.data.InvestmentList.length > 0
                        ? props.data.InvestmentList[0].Type
                        : OrderType.Percentage,
                isLoading: true,
                userInfo: UserStore.getUserInfo(),
                treasuredAssetProductIds: null,
                cashProducts: []
            };
           
        //this.subscribeToStore(TreasuredAssetsStore, () => this.onTreasuredAssetsStoreStoreChange());
    }

    /*
	private onTreasuredAssetsStoreStoreChange(): void {
        const data = TreasuredAssetsStore.getTreasuredAssetsProductIds();
        this.setState({ treasuredAssetProductIds: data });
    }
    */

    private getTreasuredAssets() {
        const _treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();

        if (!_treasuredAssetProductIds) {
            const params = getQueryParameters();

            Action.getSubAccountTreasuredAssetsProductIds(params["subaccounthierarchyid"], (data: Array<number>) => {
                this.setState({ treasuredAssetProductIds: data });
            });
        } else {
            this.setState({ treasuredAssetProductIds: _treasuredAssetProductIds });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.getTreasuredAssets();
        InvestmentSelectionAction.setIsUnderTransfer(true);
        const params = getQueryParameters();
        if (!this.props.data.InvestmentList || this.props.data.InvestmentList.length == 0) {
            BuyAction.getReuseHoldings(
                params["hierarchyid"],
                params["subaccounthierarchyid"],
                this.props.data.BatchId,
                (data: ClientTradableInvestments) => this.populateReuseHoldings(data, params)
            );
        } else {
            this.setState({ isLoading: false });
        }
    }

    isValid() {
        if (RestrictionStore.sellDisabled()) {return false;}
        const hasNoInvestment = this.props.data.InvestmentList.length == 0;
        if (hasNoInvestment) {
            this.props.showErrorMsgPopUp(["There are no holdings in this product available to sell"]);
        }

        const over95PercentValueSells: any[] = this.props.data.InvestmentList
            .filter((ele) => ele.Type == OrderType.Value
                        && ele.Instrument.MarketValue.Amount > 0
                        && ele.OrderValue >= 0.95 * ele.Instrument.MarketValue.Amount)
            .map((ele) => ele.InstrumentCode);

        if (over95PercentValueSells.length > 0) {
            this.props.showErrorMsgPopUp(["Order Value cannot be greater than or equal to 95% of market value - " + over95PercentValueSells.join(", ")]);
        }

        const onlyFullSellAllowedCheck: any[] = this.props.data.InvestmentList
            .filter((ele) => ele.Instrument.OnlyFullSellAllowed && ele.OrderValue > 0 && ele.OrderValue < ele.Instrument.MarketValue.Amount)
            .map((ele) => ele.InstrumentCode);

        if (onlyFullSellAllowedCheck.length > 0) {
            this.props.showErrorMsgPopUp(["Only full sells are allowed for these instruments - " + onlyFullSellAllowedCheck.join(", ")]);
        }

        return super.isValid() && !hasNoInvestment && over95PercentValueSells.length === 0 && onlyFullSellAllowedCheck.length === 0;
    }

    componentWillUnmount() {
        InvestmentSelectionAction.setIsUnderTransfer(false);
    }

    async populateReuseHoldings(data: ClientTradableInvestments, params): Promise<void> {
        const individual: TradableInvestment[] = data.CurrentIndividualHoldings
            .filter((ele) => ele.DisplayName != "GBP Cash");
        const model: TradableInvestment[] = data.CurrentModelHoldings
            .filter((ele) => ele.CurrQuantity > 0);

        var ids: number[] = []
        const cashProductInstanceInfo: DepositProduct[] = (await this.getCashProductInstanceInfo(individual, data.AccountServiceProposition))?.Results;
        
        if(!isNullOrEmpty(cashProductInstanceInfo)){
        this.setState(
            {
                cashProducts: cashProductInstanceInfo
                    .reduce<Record<number, DepositProduct>>(
                        (acc, product) => {
                            acc[product.ProductId] = product;
                            return acc;
                        },
                        {})
            });
            ids = Array.from(
                new Set(individual
                    .filter(x => x.Type !== ProductType.CashProduct)
                    .map(x => x.ProductId)
                    .concat(cashProductInstanceInfo.map(x => x.TemplateProductId))
                    .concat(model.map(x => x.ProductId))));
        }
        else{
            ids = Array.from(
                new Set(individual
                    .filter(x => x.Type !== ProductType.CashProduct)
                    .map(x => x.ProductId)
                    .concat(model.map(x => x.ProductId))));
        }

        if (ids.length == 0) {
            this.setState({isLoading: false});

            this.props.showErrorMsgPopUp(
                ["There are no holdings in this product available to sell"],
                true
            );

            return;
        }

        const query: InstrumentSearchQuery =
        {
            ProductIds: ids,
            ResultsPerPage: ids.length,
            ServiceProposition: data.AccountServiceProposition,
        };

        let currentAssets = [];
        InvestmentSelectionAction.searchInstruments(
            query,
            params["subaccounthierarchyid"],
            (result: Instrument[]) =>
            {
                result
                    .filter(x => x.Type === ProductType.CashProduct)
                    .forEach(x =>
                    {
                        data.CurrentIndividualHoldings
                            .filter(y => cashProductInstanceInfo
                                .find(z => z.ProductId === y.ProductId && z.TemplateProductId === x.ProductId))
                            .forEach(y =>
                            {
                                currentAssets = currentAssets.concat(
                                    transformNewItem(
                                        [{Investment: y}],
                                        this.state.orderType,
                                        OrderDirection.Sell,
                                        this.props.data.TotalValue
                                    )
                                );
                            });
                    });


                result
                    .filter(x => x.Type !== ProductType.CashProduct)
                    .forEach((ele) =>
                    {
                        const obj = data.CurrentIndividualHoldings.find(
                            (item) => item.ProductId == ele.ProductId
                        );
                        const model = data.CurrentModelHoldings.find((item) => item.ProductId == ele.ProductId);
                        if (obj) {
                            currentAssets = currentAssets.concat(
                                transformNewItem(
                                    [{Investment: obj}],
                                    this.state.orderType,
                                    OrderDirection.Sell,
                                    this.props.data.TotalValue
                                )
                            );
                        } else if (model) {
                            currentAssets = currentAssets.concat(
                                transformNewItem(
                                    [{Investment: model}],
                                    this.state.orderType,
                                    OrderDirection.Sell,
                                    this.props.data.TotalValue
                                )
                            );
                        }
                    });

                const query2: InstrumentSearchQuery = {
                    ProductWrapperTypes: [this.props.type],
                    ProductIds: ids,
                    CanBeSold: true,
                    ResultsPerPage: ids.length,
                    ServiceProposition: data.AccountServiceProposition,
                };
                InvestmentSelectionAction.searchInstruments(
                    query2,
                    params["subaccounthierarchyid"],
                    (result2: Instrument[]) =>
                    {
                        currentAssets.forEach((ele) =>
                        {
                            if (!result2.find((item) =>
                                caseInsensitiveMatch(item.ProductCode, ele.InstrumentCode) ||
                                (item.Type === ProductType.CashProduct &&
                                    cashProductInstanceInfo.find(x =>
                                        caseInsensitiveMatch(x.ProductCode, ele.InstrumentCode) &&
                                        caseInsensitiveMatch(x.TemplateProductCode, item.ProductCode)))))
                            {
                                ele.tradeable = false;
                            }
                        });

                        if (currentAssets.length == 0) {
                            this.props.showErrorMsgPopUp(
                                ["There are no holdings in this product available to sell"],
                                true
                            );
                        } else {  
                            this.props.onChange({
                                InvestmentList: currentAssets,
                                AccountAdviceType: data.ClientDetail
                                    ? data.ClientDetail.AccountAdviceType
                                    : AccountAdviceType.NotSpecified,
                                });
                        }
                        this.setState({isLoading: false});
                    }
                );
            }
        );
    }

    async getCashProductInstanceInfo(investments: TradableInvestment[], accountServiceProposition: ServiceProposition): Promise<ResultPageModel<DepositProduct>>
    {
        const cashProductInstanceIds: number[] = Array.from(
            new Set(investments
                .filter(row => row.Type === ProductType.CashProduct)
                .map(row => row.ProductId))
        );

        if (cashProductInstanceIds.length === 0)
        {
            return;
        }

        const query: DepositProductsQuery =
        {
            ProductIds: cashProductInstanceIds,
            ServiceProposition: accountServiceProposition,
            ResultsPerPage: cashProductInstanceIds.length
        };

        return new Promise((resolve) => InvestmentSelectionAction.searchDepositProducts(
            query,
            getQueryParameters()["hierarchyId"],
            (data: ResultPageModel<DepositProduct>) =>
            {
                resolve(data);
            },
            (err) =>
            {
                console.error("Failed to fetch cash products:", err);
            }
        ));
    }

    private onUnderlyingToggle(isToggle, index, row) {
        const _data = this.props.data.InvestmentList.concat();
        if (isToggle) {
            const item = _data[index];
            _data[index].isToggle = isToggle;
            if (item.underlying) {
                this.props.onChange({ InvestmentList: _data });
            } else {
                if (row.modelPortfolioType) {
                    InvestmentSelectionAction.getUnderlying(
                        row.Instrument.ProductId,
                        ModelPortfolioTabType.HubModel,
                        (data) => {
                            _data[index].underlying = data;
                            this.props.onChange({ InvestmentList: _data });
                        }
                    );
                } else {
                    InvestmentsAction.getInvestmentsModelSingle(
                        getQueryParameters()["subaccounthierarchyid"],
                        row.Instrument.InstrumentCode,
                        JsonDateParser.toJsonDateNoOffset(new Date()),
                        AssetClassType.Tier1,
                        (result) => {
                            _data[index].underlying = { ModelPortfolioProducts: [] };
                            result.forEach((ele) => {
                                ele.Investments.forEach((item) => {
                                    _data[index].underlying.ModelPortfolioProducts.push({
                                        Name: item.DisplayName,
                                        ProductCode: item.InstrumentCode,
                                        ...item,
                                        targetAllocation: (item.Allocation * 100).toFixed(2) + "%",
                                    });
                                });
                            });
                            this.props.onChange({ InvestmentList: _data });
                        }
                    );
                }
            }
        } else {
            _data[index].isToggle = isToggle;
            this.props.onChange({ InvestmentList: _data });
        }
    }

    private onInvestPathwayChange(v) {
        this.props.onChange({InvestmentPathwayAnswers : v.InvestmentPathwayAnswers});
    }

    private isSellDisabled(row): boolean
    {
        const hasOpenSellOrders: boolean = !this.isCashProduct(row) &&
            (row.Instrument.HasOpenValueSellOrder || row.Instrument.SellOrders > 0);

        return (
            hasOpenSellOrders ||
                !row.tradeable ||
                row.Instrument.CurrQuantity <= 0 ||
                (this.isCashProduct(row) && this.props.data.BatchType === BatchType.Standing)
        );
    }

    private isCashProduct(row): boolean
    {
        return row.Instrument.Type === ProductType.CashProduct;
    }

    private getTotalValue(investmentList){
        const totalValue =  investmentList
                ? investmentList.reduce((sum, curr) => (sum = Number((sum + (Number(curr.OrderValue) || 0)))), 0)
                : 0
        
        return totalValue.toFixed(2);
    }

    public render(): JSX.Element {
        const { data, type, onChange } = this.props;
        const params = getQueryParameters();

        const notSellableInvestment = data.InvestmentList
            ? data.InvestmentList
                .filter((ele) => ele.Instrument.Type !== ProductType.CashProduct &&
                    (ele.Instrument.HasOpenValueSellOrder || ele.Instrument.SellOrders > 0))
            : [];
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const selectedInvestmentProductIds = data?.InvestmentList.filter(
            (ele) =>
                ele.BuyOrSell == OrderDirection.Sell &&
                ((ele.OrderValue || 0) > 0 || (ele.OrderQuantity || 0) > 0 || (ele.OrderPercentage || 0) > 0)
        ).map((ele) => ele.Instrument.ProductId);

        const SelectedTreasuredProductIds =
            this.state.treasuredAssetProductIds != null && this.state.treasuredAssetProductIds.length > 0
                ? selectedInvestmentProductIds.filter((ele) => this.state.treasuredAssetProductIds.includes(ele))
                : [];

        // const SelectedTreasuredProductIds = selectedInvestmentProductIds.filter(ele => this.state.treasuredAssetProductIds.includes(ele));
        let canSetOrderDeferReasonType = true;

        let restrictedMessage = "An account with suspended or restricted activities cannot setup sell investments";
        const treasuredAssetsMessage =
            "As you have selected a Treasured asset, a sell instruction will be created on this occasion. The instrument will continue to remain protected from auto-disinvestment, unless this a full sell order.";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
            canSetOrderDeferReasonType = false;
        }

        return (
            <div className="ist-wrap">
                <h2 className="mb-18">
                    <span>Sell investments</span>
                </h2>

                {RestrictionStore.sellDisabled() && <Alert alertType={AlertType.Error} message={restrictedMessage} />}

                <OrderSetupReview data={data} subAccountType={type} process={ProcessType.Sell} colNum={1} />
                <MoneyTextBoxEditor
                    label="Total order value"
                    cssWrapper="control-size-245"
                    currency={CurrencyCode.GBP}
                    value={this.getTotalValue(data.InvestmentList)}
                    onBlur={(v) => {
                        const clearTable = clearAllocation(data.InvestmentList, OrderType.Value);
                        const totalMarketValue = clearTable.reduce(
                            (sum, curr) =>
                                (sum =
                                    sum +
                                    (this.isSellDisabled(curr) && data.InvestmentList.length > 1
                                        ? 0
                                        : curr.Instrument.MarketValue.Amount)),
                            0
                        );
                        const investmentList = clearTable.map((ele) => {
                            return {
                                ...ele,
                                OrderValue:
                                    this.isSellDisabled(ele) && data.InvestmentList.length > 1
                                        ? null
                                        : Number(
                                              ((ele.Instrument.MarketValue.Amount / totalMarketValue) * v).toFixed(2)
                                          ),
                                Type: OrderType.Value,
                            };
                        });
                        const total = investmentList.reduce((sum, curr) => (sum = sum + (curr.OrderValue || 0)), 0);
                        this.setState({ orderType: OrderType.Value });
                        if(data.InvestmentList.length !== 0){
                            onChange({ TotalValue: total.toFixed(2), InvestmentList: investmentList });
                        } 
                    }}
                    onChange={(v) => {
                        onChange({ TotalValue: v ? Number(v.toFixed(2)) : v });
                    }}
                    maxNumberOfDecimalPlaces={{
                        errorMessage: "only allow two decimal places",
                        value: 2,
                    }}
                    moreThan={{
                        value: 0,
                        errorMessage: "Value must larger than 0",
                    }}
                    required="Please enter"
                    alwaysValidateOnUpdate={false}
                />

                {this.props.type == SubAccountType.Npr && this.props.data.InvestmentList.some(x => x.Instrument.IsDeferred)  && canSetOrderDeferReasonType &&  
                    <SelectEditor
                        options={OrderDeferReasonTypeArrays}
                        getText={(v) => {
                            return OrderDeferReasonArraysMap[v];
                        }}
                        cssWrapper="control-size-245"
                        selected={data?.OrderDeferReasonType}
                        label="Insured fund order deferral reason"
                        onChange={(v) => onChange({ OrderDeferReasonType : v })}
                    />
                }

                <hr />
                {notSellableInvestment.length > 0 && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={`Instrument ${notSellableInvestment
                            .map((ele) => ele.InstrumentCode)
                            .toString()} currently has an open value sell order. No further sell instructions can be placed until this has been confirmed.`}
                    />
                )}
                <div className="row mt-5">
                    <div className="col-6"></div>
                    <div className="col-6 cell-right">
                        {/* <QuantitySwitch
                            type={this.state.orderType}
                            onChange={(v) => {
                                onChange({ InvestmentList: clearAllocation(data.InvestmentList, v) });
                                this.setState({ orderType: v });
                            }}
                            hasModel={
                                data.InvestmentList &&
                                data.InvestmentList.some((ele) =>
                                    [ProductType.ManagedModelPortfolio, ProductType.TailoredModelPortfolio].includes(
                                        ele.Instrument.Type
                                    )
                                )
                            }
                        /> */}
                    </div>
                </div>

                {SelectedTreasuredProductIds.length > 0 && (
                    <Alert alertType={AlertType.Warning} message={treasuredAssetsMessage} />
                )}

                <PartLoading isLoading={this.state.isLoading}>
                    <BuySellAllocationTable
                        totalValue= {this.getTotalValue(data.InvestmentList)}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onToggle={(isToggle, index, rowData) => this.onUnderlyingToggle(isToggle, index, rowData)}
                        data={data.InvestmentList}
                        onChange={(list) => {
                            const total = list
                            ? list.reduce(
                                (sum, curr) => (sum = sum + (curr.OrderValue ? Number(Number(curr.OrderValue).toFixed(2)) : 0)),
                                  0
                              )
                            : 0;
                            onChange({
                                InvestmentList: list,
                                TotalValue: Number(total).toFixed(2),
                            });
                        }}
                        orderType={OrderType.Value}
                        process={ProcessType.Sell}
                        onRef={(ref) => this.appendChild(ref)}
                        onTreasuredAssetChange={() => {}}
                        ChecktreasuredAsset={this.state.treasuredAssetProductIds}
                        depositProducts={this.state.cashProducts}
                        batchType={data.BatchType}
                    />
                    {hasDecisionMaker(data.InvestmentList) && (
                        <DecisionMaker
                            onRef={(ref) => this.appendChild(ref)}
                            data={data}
                            onChange={(v) => onChange(v)}
                            clAccountId={params["claccountid"]}
                            headAccountHierarchyId={clientAccount?.HierarchyId}
                            companyCode={clientAccount?.Company}
                            accountAdviceType={
                                clientAccount?.Discretionary
                                    ? AccountAdviceType.Discretionary
                                    : AccountAdviceType.NonDiscretionary
                            }
                            showErrorMsgPopUp={(msg, now) => this.props.showErrorMsgPopUp(msg, now)}
                        />
                    )}
                </PartLoading>
            </div>
        );
    }
}
